var contactData = {
    section:"Contact me",
    button:"Send me an Email",
}

exports.contactData = contactData